import React, { useState } from 'react';
import {ChromePicker} from "react-color";
import styled from "styled-components";
// import CrossFill from "../../../../assets/images/layout4/cross-lines.svg";
import {COLORS} from "../../theme";

// background-image: ${props => !props.color ? `url(${CrossFill})` : ''};
const Color = styled.div `
  display: inline-block;
  background-color: ${props => props.color};
  width: 30px;
  height: 30px;
  border-radius: 5px;
  border-color: ${COLORS.lightGrey};
  border-width: 1px;
  border-style: solid;
  float: right;
  cursor: ${props => props.disabled ? 'default' : 'pointer'}
`

export default function ColorPicker({value, onChange, disabled}) {
  const [displayColorPicker, setDisplayColorPicker] = useState(false)

  const handleClick = () => setDisplayColorPicker(!disabled && !displayColorPicker)
  const handleClose = () => setDisplayColorPicker(false)
  const handleChangeComplete = (color) => onChange(color.hex)


  const popover = {
    position: 'absolute',
    zIndex: '2',
  }
  const cover = {
    position: 'fixed',
    top: '0px',
    right: '35px',
    bottom: '0px',
    left: '0px',
  }

  return (
    <>
      <Color color={value} onClick={handleClick} disabled={disabled} />
      { displayColorPicker && <div style={ popover }>
        <div style={ cover } onClick={ handleClose }/>
        <ChromePicker color={value} onChangeComplete={ handleChangeComplete }/>
      </div>}
    </>
  )
}
